import * as API from '../api'
export const FETCH_IMAGETIME = 'FETCH_IMAGETIME'
export const FETCHING_IMAGETIME = 'FETCHING_IMAGETIME'
export const FETCH_IMAGETIME_ERROR = 'FETCH_IMAGETIME_ERROR'
export const FETCH_IMAGESTIME = 'FETCH_IMAGESTIME'
export const FETCH_IMAGESTIMEALL = 'FETCH_IMAGESTIMEALL'
export const FETCHING_IMAGESTIME = 'FETCHING_IMAGESTIME'
export const FETCH_IMAGESTIME_ERROR = 'FETCH_IMAGESTIME_ERROR'
export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'
export const CHANGE_IMAGETIME = 'CHANGE_IMAGETIME'
export const DELETE_IMAGETIME = 'DELETE_IMAGETIME'
export const ADD_IMAGETIME = 'ADD_IMAGETIME'
export const EDIT_IMAGETIME = 'EDIT_IMAGETIME'
export const FORM_TOUCHED = 'FORM_TOUCHED'
export const NEW_FORM_IMAGETIME = 'NEW_FORM_IMAGETIME'
export const IMAGETIME_FORM_ERROR = 'IMAGETIME_FORM_ERROR'
export const CHANGE_PAGE = 'CHANGE_PAGE'
export const CHANGE_PER_PAGE = 'CHANGE_PER_PAGE'
export const CHANGE_ORDER_COLUMN = 'CHANGE_ORDER_COLUMN'
export const CHANGE_ORDER_DIRECTION = 'CHANGE_ORDER_DIRECTION'
export const RESET_STATE = 'RESET_STATE'

export const openModal = () => {
  return dispatch => {
    dispatch({ type: OPEN_MODAL })
  }
}

export const handleChangeImageTime = imageTime => {
  return dispatch => {
    dispatch({ type: CHANGE_IMAGETIME, imageTime })
  }
}

const getDuplicateKeyField = errorMessage => {
  const [x, field = ''] = /collection: .* index: (.*)_/.exec(errorMessage) // eslint-disable-line
  return field
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const handleImageTimeError = (res, dispatch) => {
  const { data: errorMessage = '' } = res

  switch (true) {
    case errorMessage.includes('duplicate key error'):
      dispatch({
        type: FORM_TOUCHED
      })
      dispatch({
        type: IMAGETIME_FORM_ERROR,
        field: getDuplicateKeyField(errorMessage),
        message: `${capitalizeFirstLetter(getDuplicateKeyField(errorMessage))} já cadastrado.`
      })
      return Promise.reject(res)

    default:
      break
  }
}

export const newFormImageTime = imageTime => {
  return dispatch => {
    dispatch({ type: NEW_FORM_IMAGETIME })
  }
}

export const setImageTimeFormTouched = imageTime => {
  return dispatch => {
    dispatch({ type: FORM_TOUCHED })
  }
}

export const closeModal = () => {
  return dispatch => {
    dispatch({ type: CLOSE_MODAL })
  }
}

export const restoreImageTime = id => {
  return dispatch => {
    dispatch({ type: FETCHING_IMAGESTIME })
    return API.imagesTime
      .restoreImageTime(id)
      .then(({ data }) => {
        dispatch({ type: EDIT_IMAGETIME, imageTime: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_IMAGESTIME_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleImageTimeError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const handleChangePage = page => {
  return dispatch => {
    dispatch({ type: CHANGE_PAGE, page })
  }
}

export const handleChangePerPage = perPage => {
  return dispatch => {
    dispatch({ type: CHANGE_PER_PAGE, perPage })
  }
}

export const changeOrderColumn = column => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_COLUMN, column })
  }
}

export const changeOrderDirection = direction => {
  return dispatch => {
    dispatch({ type: CHANGE_ORDER_DIRECTION, direction })
  }
}

export const resetState = () => {
  return dispatch => {
    dispatch({ type: RESET_STATE })
  }
}

export const fetchImagesTimeAll = () => {
  return dispatch => {
    API.imagesTime.getImagesTimeAll().then((res = {}) => {
      const { data } = res
      dispatch({ type: FETCH_IMAGESTIMEALL, imagesTime: data })
    })
  }
}

export const fetchImagesTime = options => {
  return dispatch => {
    dispatch({ type: FETCHING_IMAGESTIME })
    return API.imagesTime
      .getImagesTime(options)
      .then((res = {}) => {
        const { data } = res
        dispatch({
          type: FETCH_IMAGESTIME,
          imagesTime: data.items,
          length: data.length,
          page: data.page,
          order: data.order,
          rowsPerPage: data.rowsPerPage
        })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_IMAGESTIME_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const deleteImageTime = id => {
  return dispatch => {
    dispatch({ type: FETCHING_IMAGESTIME })
    return API.imagesTime
      .deleteImageTime(id)
      .then(({ data: imageTime }) => {
        dispatch({ type: DELETE_IMAGETIME, imageTime })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_IMAGESTIME_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const addImageTime = imageTime => {
  return dispatch => {
    dispatch({ type: FETCHING_IMAGESTIME })
    dispatch({ type: FETCHING_IMAGETIME })
    return API.imagesTime
      .addImageTime(imageTime)
      .then(({ data }) => {
        dispatch({ type: ADD_IMAGETIME, imageTime: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        handleImageTimeError(response, dispatch)
        dispatch({
          type: FETCH_IMAGESTIME_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}

export const editImageTime = imageTime => {
  return dispatch => {
    dispatch({ type: FETCHING_IMAGESTIME })
    dispatch({ type: FETCHING_IMAGETIME })
    return API.imagesTime
      .editImageTime(imageTime)
      .then(({ data }) => {
        dispatch({ type: EDIT_IMAGETIME, imageTime: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_IMAGESTIME_ERROR,
          err: message || 'Serviço indisponível'
        })
        handleImageTimeError(response, dispatch)
        return Promise.reject(response)
      })
  }
}

export const fetchImageTime = id => {
  return dispatch => {
    dispatch({ type: FETCHING_IMAGETIME, clear: true })
    dispatch({ type: OPEN_MODAL })
    return API.imagesTime
      .getImageTime(id)
      .then(({ data }) => {
        dispatch({ type: FETCH_IMAGETIME, imageTime: data })
      })
      .catch(err => {
        const { response = {} } = err
        const { data = {} } = response
        const { message } = data
        dispatch({
          type: FETCH_IMAGETIME_ERROR,
          err: message || 'Serviço indisponível'
        })
        return Promise.reject(err)
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/imagesTimes.js